export default "__VITE_ASSET__C6_3ssmv__"